//Live serve
// const LOCAL_URL = "http://localhost:3000/";
const SERVER_URL = "https://mottruck.com:3001/api/";
const FRONT_END_SERVER_URL = "https://mottruck.com/";
export const IMAGE_URL = "https://mottruck.com:3001/";


//local  server (testing  env)
// const SERVER_URL = "https://test.mottruck.com:3001/api/";
// export const IMAGE_URL = "https://test.mottruck.com:3001/";
// const FRONT_END_SERVER_URL = "https://test.mottruck.com/";

// const SERVER_URL = "http://localhost:3001/api/";





const ON_SERVER = process.env.REACT_APP_ON_SERVER;
export const BASE_URL = SERVER_URL;
export const DOWNLOAD_FILE_URL = `${IMAGE_URL}server/`;
export const URL_LINK = FRONT_END_SERVER_URL;
